import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    OrderPartsHelpContents,
    Title,
    SubTitle,
    Paragraph,
    Image,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

const IMG_PATH = `${ASSETS_PATH}/img/order-help/arrowlength`;

interface Props {
    className?: string;
}

export const ArrowlengthInner: FC<Props> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            矢尺（矢の長さ）の決め方
        </Title>
        <SubTitle>矢尺（やじゃく）とは</SubTitle>
        <Paragraph>
            「矢尺」とは、筈(※1)からシャフトの先端(※2)までの長さで、
            矢尻(※3)を含まない長さのことを指します。また矢尻を含む場合は「矢の全長」と呼ばれます。
        </Paragraph>
        <Image src={`${IMG_PATH}/about-arrowlength.png`} />

        <SubTitle>矢尺の決め方</SubTitle>
        <Paragraph>
            左腕を伸ばして、体の中心から左手の中指の先の長さを矢束（やづか）と呼び、
            その矢束に10cm～15cm程度を足した長さが初心者に適した矢尺（矢の長さ）となります。
            矢尺は熟練度よって長さが変わりますので中級者以上の方は、
            指導を受けている方に相談して決めてみるとよいでしょう。
            上達するにつれて少しずつ矢尺を短くしていくことが一般的です。
            ちなみに、正しい矢束で弓を引くことができる有段者の場合は、
            矢束に5〜10cmの長さを足した長さが適していると言われています。
        </Paragraph>
        <Image src={`${IMG_PATH}/how-to.png`} />
    </OrderPartsHelpContents>
);

export const OrderPartsHelpArrowlength: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <ArrowlengthInner />
            </div>
        </div>
    </Panel>
);
